<template>
  <div>
    <slots-head
      :item="item"
      :type="type"
      @saveNameEdit="(value, item) => saveNameEdit(value, item)"
      @deleteItem="(item) => deleteItem(item)"
    ></slots-head>
    <div style="width:100%;height:100%;overflow-x:auto;">
      <div :style="`width:${width};height:100%`" ref="myChart"></div>
    </div>
  </div>
</template>

<script>
import { MdcCardServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import mixin from './cardmixin.vue'
const mdcsp = new MdcCardServiceProxy()

export default {
  name: 'utilization-chart',
  mixins: [mixin],
  data() {
    return {
      length: 0
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    width() {
      if (this.length <= 7) {
        return '100%'
      }
      return 100 * this.length + 'px'
    }
  },
  methods: {
    async getList() {
      const data = await mdcsp.workStationOee()
      console.log(data)
      const keys = []
      const values = []
      this.length = data.length || 0
      await this.$nextTick()
      data.forEach((item) => {
        keys.push(item.workStationName)
        values.push(item.oeeValue)
      })
      var myChart = this.$echarts.init(this.$refs.myChart)
      const option = {
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: keys,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: (value) => {
                return value + '%'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '60%',
            data: values
          }
        ]
      }

      myChart.setOption(option)
    }
  }
}
</script>

<style></style>
